<div class="modal-header">
    <h3 class="mb-0">{{ title | translate }}</h3>
    <button type="button" class="btn-close" data-testid="shared-confirmation-modal-close-btn" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body pt-5">
    <p class="text-center">{{ message | translate }}</p>
</div>

<div class="modal-footer">
    <button type="button" class="lite-btn" data-testid="shared-confirmation-modal-cancel-btn" (click)="activeModal.dismiss()">
        {{ cancelLabel | translate }}
    </button>
    <button type="button" class="primary-btn" data-testid="shared-confirmation-modal-confirm-btn" (click)="activeModal.close(true)">
        {{ confirmLabel | translate }}
    </button>
</div>